import { Box, type BoxProps } from '@chakra-ui/react';
import { type HTMLMotionProps, motion } from 'framer-motion';
import type { ComponentType } from 'react';

export type MotionBoxProps = Omit<
  BoxProps,
  keyof HTMLMotionProps<'div'> | 'transition'
> &
  HTMLMotionProps<'div'> & { inert?: string };

export const MotionBox = motion.create(Box) as ComponentType<MotionBoxProps>;
